// extracted by mini-css-extract-plugin
export default {"codeInput":"verifyEmail_codeInput__2iLrh","loginBox":"verifyEmail_loginBox__0YbuS","sendAgain":"verifyEmail_sendAgain__Asc2s"};